module.exports = __webpack_public_path__ + "static/02-1066cae45d3850eecda29293ecec631a.jpg";